import { useEffect,useState,Fragment } from 'react';
import services from '../../../services/index'
import { HiOutlineBell } from "react-icons/hi";

import { notification,Modal } from 'antd'
import { Link } from "react-router-dom";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { myDateFormat } from "../../../utils/utils";
import { useNavigate } from "react-router";
import { Menu, Dropdown } from 'antd'; 
import commonObj from '../../../utils/Common';

const NavNotification = ({userId}) => {
    const navigate = useNavigate();
    const [isView, setIsView] = useState('');
    const[loaderOpen, setloaderOpen] = useState(true)
    const[msgCount, setMsgCount] = useState(0)
    const handleloaderclose = () => setloaderOpen(false)
    const [order,setOrder] = useState({list:[],url:'',count:0});
    const [saveloading, setsaveLoading] = useState(false);
    const[mark,setMark] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10
    });

    

    useEffect(()=>{ 
        getMsgCount();  
        getData()
    },[mark]);

    async function getMsgCount(){
        let filterData = {cinfo:btoa(+userId)};  
        const res = await services.notificationService.unreadNotification(filterData)
        if(res?.status===1){
            setMsgCount(res?.data?.notification)
        }
       // console.log('msgcount',res)
    }

    async function getData(){
        setsaveLoading(true) 
        let filterData = {limit:10,order:{orderby:'createdAt',type:'DESC'}};
        filterData['cinfo'] = btoa(+userId);  // Buyer
        const res = await services.notificationService.getNotificationList(filterData)
        setOrder({list:res?.data?.result?.rows});           
        setsaveLoading(false)
        handleloaderclose()
        //console.log('msg data list',res)
    }  

    const MarkAsRead = async (msgId, isRead) => {
        if(!isRead){
            const res = await services.notificationService.changeStatus({id:msgId})
            if(res) setMark(mark+1)
        }
    }
    /****End*****/
    

    const menu = (
        <Menu>
          
            <div className="block px-4 py-2 font-medium text-center text-gray-800 rounded-t-lg bg-gray-500 dark:bg-gray-800 dark:text-white">Notifications</div>
            <div style={{maxHeight:337+'px',overflow:'scroll'}}>
                { 
                order?.list?.length > 0 ? (
                order?.list.map((odr,key) => (
                    <Menu.Item key={odr.id}>
                <div key={key} className="divide-y w-4/12 divide-gray-500 dark:divide-gray-700">
                    <a href="#" onClick={(e)=>MarkAsRead(odr.id,odr.isRead)} className="flex px-4 py-1 hover:bg-gray-100 dark:hover:bg-gray-700">
                    <div className="w-full ps-3">
                        <div className={`${!odr?.isRead ? 'text-black-500 dark:text-black-400': 'text-gray-500 dark:text-gray-400'} text-sm mb-1.5 `}><span className={`${!odr?.isRead ? 'font-bold text-black-900': 'text-gray-900'}  dark:text-white`}>{odr.messageData}</span></div>
                        <div className="text-xs text-gray-600 dark:text-gray-500"> {myDateFormat(odr.createdAt, true)}</div>
                    </div>
                    </a>
                </div>
                </Menu.Item>
                ))
                ) : (<div className="divide-y w-4/12 divide-gray-500 dark:divide-gray-700" style={{textAlign:'center'}}>
                    <a href="#" className="flex px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700">
                    <div className="w-full ps-3">
                        <div className="text-gray-500 text-sm mb-1.5 dark:text-gray-400"> {commonObj.getLabel('No_Message_Found')}</div>
                    </div></a></div>
                    )
                }
            </div>
            <Link to="/user/mynotification"  className="block py-2 text-sm font-medium text-center text-white rounded-b-lg bg-red-800 hover:bg-red-700 hover:text-white">
                <div className="inline-flex items-center ">{commonObj.getLabel('View_all')}</div>
            </Link>
        </Menu>
      );

    return ( 
        <> 
         <Dropdown overlay={menu} 
          trigger={['click']}> 
                <HiOutlineBell className=" text-white  ">                
                <a className="ant-dropdown-link" 
                    onClick={e => {e.preventDefault()} }> 
                </a> 
            </HiOutlineBell>
        </Dropdown>  
            { msgCount>0 && <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-rose-600 border-2 border-[--theme-color] rounded-full -top-2 -right-2 ">{msgCount}</div> }
        </>
        );
    }

export default NavNotification;
